import React from 'react';

	
class ItemMenuCerrarSesion extends React.Component {
	
	render(){
		 return (
			<a href="" class="dropdown-item" onClick = {this.cerrarSesion.bind(this)}>Cerrar sesi&oacute;n</a>
		)
	}
	
	cerrarSesion( event ){
		event.preventDefault();
		localStorage.clear();
		window.location.reload();
	}
}
export default ItemMenuCerrarSesion;